module.exports = "/dist/img/giftshopper_fabric4.c0e8319c.jpg";